import { type FooterNavLink } from '~/interfaces/HeaderFooterNavV2';
import { useLayoutStore } from '~/providers/layout-store-provider';

import styles from './FooterGeneralLinks.module.css';

const GeneralLink = ({ link, name }: Partial<FooterNavLink>) =>
<a
  className={styles.generalLinksNavItem}
  data-testid="footer-general-link"
  href={link}>

		{name}
	</a>;


const shouldNotShowLinks = (links: FooterNavLink[]) => {
  return !!(!links || !links.length);
};

export const FooterGeneralLinks = () => {
  const generalLinks = useLayoutStore((s) => s.footerData.levelThree);
  if (shouldNotShowLinks(generalLinks)) return null;

  return (
    <section
      aria-label="Footer General Links Section"
      className={styles.generalLinksWrapper}
      data-testid="footer-general-links-container">

			<nav
        aria-label="Footer General Links Navigation"
        className={styles.generalLinksNavContainer}>

				{generalLinks.map(({ link, name }) =>
        <GeneralLink key={name} link={link} name={name} />
        )}
			</nav>
		</section>);

};